/* global femcare */

femcare.quiz.shareable = {
    init: function() {
        var $quiz = $('.quiz.quiz--shareable');

        if (
            !$quiz.length ||
            !window.quiz ||
            !window.quiz.results ||
            !window.quiz.results.length
        ) {
            return;
        }

        function ShareableQuiz() {
            femcare.quiz.BaseQuiz.call(this, $quiz);

            this.answerResultMap = {};
            this.selectedAnswerId = null;
            this.$detachedSteps = this.$steps.detach();
            this.$form = this.$questionnaire.find('form');

            this.initAnswerResultMap(window.quiz.results);
        }

        ShareableQuiz.prototype = Object.create(femcare.quiz.BaseQuiz.prototype);
        ShareableQuiz.prototype.constructor = ShareableQuiz;

        ShareableQuiz.prototype.initDerivedEventHandlers = function() {
            this.$questionnaire.on(
                'click',
                'input',
                $.proxy(this.onAnswerSelected, this)
            );
        };

        ShareableQuiz.prototype.onAnswerSelected = function(e) {
            var $answer = $(e.currentTarget);
            this.$form.find('.has-error').removeClass('has-error');
            this.selectedAnswerId = $answer.val();
        };

        ShareableQuiz.prototype.initAnswerResultMap = function(results) {
            results.forEach(
                $.proxy(function(result) {
                    if (result.answerGroups && result.answerGroups.length) {
                        result.answerGroups.forEach(
                            $.proxy(function(answerGroup) {
                                var answerId =
                                    answerGroup && answerGroup.length && answerGroup[0];
                                if (answerId) {
                                    this.answerResultMap[String(answerId)] = result;
                                }
                            }, this)
                        );
                    }
                }, this)
            );
        };

        ShareableQuiz.prototype.prepareQuestionnaire = function() {
            this.$form.find('.has-error').removeClass('has-error');
            this.$form.trigger('reset');

            var $potentialNextQuestions = this.$detachedSteps;
            var $currentQuestion = this.$form.find('.questionnaire__step--question');

            if ($currentQuestion.length) {
                $potentialNextQuestions = $potentialNextQuestions.not($currentQuestion);
                $currentQuestion.detach();
            }

            var $nextQuestion = this.getRandomQuestion($potentialNextQuestions);
            this.renderAnswers($nextQuestion);

            this.selectedAnswerId = null;
            this.$form.append($nextQuestion);
            this.$steps = $nextQuestion;
        };

        ShareableQuiz.prototype.getRandomQuestion = function($potentialQuestions) {
            var index = Math.floor(Math.random() * $potentialQuestions.length);
            var $question = $($potentialQuestions[index]);

            return $question;
        };

        ShareableQuiz.prototype.renderAnswers = function($question) {
            var $answers = $question.find('.form-radio-control');
            var $answerRow = $answers.first().parent();

            var $answersArray = $.makeArray($answers);
            femcare.shared.util.shuffleArray($answersArray);

            $answerRow.empty();
            $answersArray.forEach(function(answer) {
                $answerRow.append(answer);
            });
        };

        ShareableQuiz.prototype.prepareResult = function() {
            var title = this.answerResultMap[this.selectedAnswerId].title;
            var description = this.answerResultMap[this.selectedAnswerId].description;
            var imageUri = this.answerResultMap[this.selectedAnswerId].externalImageUri;
            var imageSrc =
                imageUri || this.answerResultMap[this.selectedAnswerId].images[0].src;

            this.renderResult(title, description, imageSrc);
        };

        ShareableQuiz.prototype.renderResult = function(title, description, imageSrc) {
            var $resultHeading = this.$result.find('.quiz-result__heading');
            var $resultBody = this.$result.find('.quiz-result__body');
            var $resultImage = this.$result.find('.quiz-result__image img');
            var $facebookShare = this.$result.find('.share-button');

            $resultHeading.text(title);
            $resultBody.empty().append(description);
            $resultImage.attr('src', imageSrc);

            var facebookSharerUri = $facebookShare.attr('data-facebook-sharer-uri');
            var currentLocation = window.location.href.split('?')[0];
            var params = '?quizId=' + this.id + '&quizResultId=' + this.answerResultMap[this.selectedAnswerId].id;
            var uri = facebookSharerUri + encodeURIComponent(currentLocation + params);
            $facebookShare.attr('href', uri);
        };

        new ShareableQuiz();
    }
};
